<template>
    <button
        v-tippy="t('editorToggleTextAlignRight')"
        :class="[
            buttonState(true, editor.isActive({ textAlign: 'right' })),
            'flex-none rounded p-1 text-sm',
        ]"
        @click="editor.chain().focus().setTextAlign('right').run()"
    >
        <MdiFormatAlignRight class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatAlignRight from 'materialdesignicons-vue3/icons/MdiFormatAlignRight.js';

    defineExpose({
        name: 'TextAlignRightButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
